import { render } from "./DefaultPage.vue?vue&type=template&id=aecd141a&scoped=true"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"

import "./DefaultPage.vue?vue&type=style&index=0&id=aecd141a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aecd141a"]])

export default __exports__